'use client'

import { Dropdown, Label } from '@heroui/react'
import { Monitor, Moon, Sun } from 'lucide-react'
import { useTranslations } from 'use-intl'
import { useTheme } from '~/components/providers/theme-provider'

export function ModeToggle() {
  const { theme, setTheme } = useTheme()
  const t = useTranslations('CommonControls')

  return (
    <Dropdown>
      <Dropdown.Trigger
        aria-label={t('themeToggle')}
        className="nav-icon-trigger button button--icon-only button--sm button--ghost relative"
      >
        <Sun className="h-[20px] w-[20px] shrink-0 scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
        <Moon className="absolute inset-0 m-auto h-[20px] w-[20px] shrink-0 scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
      </Dropdown.Trigger>
      <Dropdown.Popover>
        <Dropdown.Menu
          aria-label={t('themeSelection')}
          onAction={key => setTheme(key as any)}
          selectedKeys={new Set([theme])}
          selectionMode="single"
        >
          <Dropdown.Item key="light" id="light" textValue={t('light')}>
            <div className="flex items-center gap-2">
              <Sun className="h-4 w-4" />
              <Label>{t('light')}</Label>
            </div>
            <Dropdown.ItemIndicator />
          </Dropdown.Item>
          <Dropdown.Item key="dark" id="dark" textValue={t('dark')}>
            <div className="flex items-center gap-2">
              <Moon className="h-4 w-4" />
              <Label>{t('dark')}</Label>
            </div>
            <Dropdown.ItemIndicator />
          </Dropdown.Item>
          <Dropdown.Item key="system" id="system" textValue={t('system')}>
            <div className="flex items-center gap-2">
              <Monitor className="h-4 w-4" />
              <Label>{t('system')}</Label>
            </div>
            <Dropdown.ItemIndicator />
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown>
  )
}
